module.exports = "<wow-delivery-saver-plan-tag ng-if=\"::$ctrl.plan.Metadata.Tag\" tag=\"::$ctrl.plan.Metadata.Tag\" />\r\n<div class=\"u-flex u-flexSpaceBetween u-flexCenterCross\">\r\n    <h2 class=\"deliverySaverPlan-name\">{{ ::$ctrl.plan | deliverySaverShortName }}</h2>\r\n    <wow-price price=\"::$ctrl.plan.Price\" per=\"::$ctrl.plan | deliverySaverBillingFrequencyUnit\" price-class-modifier=\"price--withPer\" />\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/deliverysaver/plan/delivery-saver-plan.component.html
// module id = 367
// module chunks = 0 9